export default "__VITE_ASSET__IHHB63bx__"